export const MIN_WIDTH_MOBILE = 1022;
